// under construction... this is not used.

export class Reports {
  constructor(readonly userIds: string[] = []) {}
}
